import React from 'react';
import { motion } from 'framer-motion';
import { Leaf } from 'lucide-react';
const pains = ['Tardás 2-4 horas en crear cada plan de forma manual', 'No podés atender más de 20-30 clientes sin colapsar', 'Los prospectos preguntan el precio y desaparecen sin comprar', 'No tenés contenido que atraiga clientes de forma consistente', 'Sin producto empaquetado que se pueda vender sin tu intervención', 'No sabés qué pedirle a la IA para que produzca algo profesional', 'Cada mes empezás desde cero sin ingresos recurrentes garantizados', 'El negocio depende 100% de referidos que no escalan'];
export function PainSection() {
  return <section className="pt-14 pb-0 relative overflow-hidden" data-id="element-423">
      <div className="container mx-auto px-4 relative z-10" data-id="element-424">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative max-w-3xl mx-auto mb-12" data-id="element-425">
          {/* Outer neon glow */}
          <div className="absolute -inset-1 bg-gradient-to-r from-electric via-energy to-electric rounded-3xl blur-xl opacity-40 animate-pulse" data-id="element-426"></div>

          {/* Frame */}
          <div className="relative bg-gradient-to-br from-graphite via-petroleum to-graphite border-2 border-electric rounded-3xl p-8 md:p-10 text-center overflow-hidden shadow-2xl shadow-electric/30" data-id="element-427">
            {/* Decorative leaf flourish in background */}
            <div className="absolute -top-24 -right-24 opacity-10 pointer-events-none rotate-45" data-id="element-428">
              <Leaf className="w-64 h-64 text-electric" data-id="element-429" />
            </div>
            <div className="absolute -bottom-24 -left-24 opacity-10 pointer-events-none -rotate-45" data-id="element-430">
              <Leaf className="w-64 h-64 text-electric" data-id="element-431" />
            </div>

            {/* Organic dot pattern background */}
            <div className="absolute inset-0 opacity-[0.18] pointer-events-none" style={{
            backgroundImage: 'radial-gradient(circle, rgba(125,255,47,0.35) 1.2px, transparent 1.5px)',
            backgroundSize: '18px 18px'
          }} data-id="element-432"></div>

            {/* Corner accents */}
            <div className="absolute top-0 left-0 w-16 h-16 border-t-4 border-l-4 border-electric rounded-tl-3xl pointer-events-none" data-id="element-433"></div>
            <div className="absolute top-0 right-0 w-16 h-16 border-t-4 border-r-4 border-electric rounded-tr-3xl pointer-events-none" data-id="element-434"></div>
            <div className="absolute bottom-0 left-0 w-16 h-16 border-b-4 border-l-4 border-electric rounded-bl-3xl pointer-events-none" data-id="element-435"></div>
            <div className="absolute bottom-0 right-0 w-16 h-16 border-b-4 border-r-4 border-electric rounded-br-3xl pointer-events-none" data-id="element-436"></div>

            <div className="relative z-10" data-id="element-437">
              <div className="inline-flex items-center gap-2 bg-electric text-graphite px-4 py-1.5 rounded-full text-xs font-extrabold uppercase tracking-wider mb-5 shadow-lg shadow-electric/40" data-id="element-438">
                <Leaf className="w-3.5 h-3.5" data-id="element-439" />
                El Problema Real
              </div>
              <h2 className="text-3xl md:text-4xl font-extrabold mb-4" data-id="element-440">
                ¿Cuántos meses más vas a crear planes manualmente y{' '}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-electric via-energy to-electric drop-shadow-[0_0_12px_rgba(125,255,47,0.4)]" data-id="element-441">
                  vivir de tu tiempo?
                </span>
              </h2>
              <div className="mx-auto h-px w-32 bg-gradient-to-r from-transparent via-electric to-transparent opacity-70 mb-4" data-id="element-442"></div>
              <p className="text-lg text-textsecondary" data-id="element-443">
                Querés escalar tu negocio de nutrición pero terminás atrapado en
                un modelo donde cada peso que entrás depende de que vos estés
                presente, disponible y produciendo.
                <br data-id="element-444" />
                <br data-id="element-445" />
                <span className="text-white font-medium" data-id="element-446">
                  No es falta de conocimiento. Es falta de un sistema.
                </span>
              </p>
            </div>
          </div>
        </motion.div>

        <div className="max-w-4xl mx-auto grid gap-4 md:grid-cols-2" data-id="element-447">
          {pains.map((pain, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-petroleum p-5 rounded-xl border border-electric/10 flex items-start gap-4 hover:border-electric/30 transition-colors" data-id="element-448">
              <Leaf className="w-6 h-6 text-electric shrink-0 mt-0.5" data-id="element-449" />
              <span className="text-textsecondary" data-id="element-450">{pain}</span>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mt-10" data-id="element-451">
          <h3 className="text-2xl md:text-3xl font-bold text-electric" data-id="element-452">
            ¿Y si este fuera el último mes que pasás así?
          </h3>
        </motion.div>
      </div>
    </section>;
}